import { inject } from '@angular/core';
import {
    CanActivateFn,
    Router,
} from '@angular/router';

import { AuthService } from '../../features/authentication/services/auth.service';

export const landingGuard: CanActivateFn = async () => {
    const auth = inject(AuthService);
    const router = inject(Router);

    await auth.initialize();

    if (auth.authenticated) {
        return router.createUrlTree(['/dashboard']);
    }

    return true;
};